/** Validate the server's payable quote before presenting a charge. */
export function readUpgradeQuote(value, now = Date.now()) {
  if (!value || typeof value.quoteId !== 'string' || !value.quoteId || value.quoteId.length > 8192
    || value.currency !== 'usd' || !Number.isSafeInteger(value.amountMinor) || value.amountMinor <= 0) return null;
  const { completedSections, currentSection, remainingSections, totalSections, currentPeriodEndAt, expiresAt } = value;
  if (![completedSections, currentSection, remainingSections, totalSections, currentPeriodEndAt, expiresAt].every(Number.isSafeInteger)
    || totalSections < 1 || totalSections > 52 || completedSections < 0 || completedSections >= totalSections
    || currentSection !== completedSections + 1 || remainingSections !== totalSections - completedSections
    || currentPeriodEndAt <= now || expiresAt <= now || expiresAt > currentPeriodEndAt) return null;
  return { quoteId: value.quoteId, amountMinor: value.amountMinor, currency: value.currency,
    completedSections, currentSection, remainingSections, totalSections, currentPeriodEndAt, expiresAt };
}

export function upgradePriceText(quote, language = 'en') {
  return new Intl.NumberFormat(language, { style: 'currency', currency: quote.currency.toUpperCase() }).format(quote.amountMinor / 100);
}

/** Only an existing Stripe invoice may resume payment without a new quote. */
export function pendingUpgradeInvoiceUrl(value, planType) {
  if (value?.paymentPending !== true || value.code !== 'upgrade_payment_required'
    || value.planType !== planType || typeof value.url !== 'string') return null;
  try {
    const url = new URL(value.url);
    return url.protocol === 'https:' && url.hostname === 'invoice.stripe.com'
      && !url.username && !url.password && !url.port && url.pathname.startsWith('/i/')
      ? url.href : null;
  } catch (_) { return null; }
}
